var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"logo"}},[(_vm.merchant && _vm.merchant.name)?_c('div',{attrs:{"id":"merchant"}},[_c('h4',{attrs:{"data-cy":"merchant-name"}},[_vm._v(_vm._s(_vm.merchant.name))])]):_c('div',[_c('BlytzLogo',{attrs:{"id":"blytz-logo"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }